import { User } from "@src/utils/user";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = { user: User; minimized?: boolean };

const ClubProfileContainer = ({ user, minimized = true }: Props) => {
  const { t } = useTranslation();
  const InfoField: React.FC<{
    icon: string;
    label: string;
    value?: string;
  }> = ({ icon, label, value }) => (
    <div className="grid grid-cols-[20px,1fr] items-center">
      <img src={icon} className="size-[15px]" />
      <div className="font-semibold">{label}:</div>
      <div />
      <div>{value}</div>
    </div>
  );
  const fields = [
    {
      icon: "/images/icons/user.svg",
      label: t("main.profileViewTabs.editProfile.form.companyName"),
      value: "Test data",
    },
    {
      icon: "/images/icons/user.svg",
      label: t("main.profileViewTabs.editProfile.form.legalForm"),
      value: "Test data",
    },
    {
      icon: "/images/icons/user.svg",
      label: t("main.profileViewTabs.editProfile.form.companyRegistration"),
      value: "Test data",
    },
    {
      icon: "/images/icons/user.svg",
      label: t("main.profileViewTabs.editProfile.form.vatID"),
      value: "Test data",
    },
    {
      icon: "/images/icons/user.svg",
      label: t("main.profileViewTabs.editProfile.form.annualsales"),
      value: "Test data",
    },
    {
      icon: "/images/icons/user.svg",
      label: t("components.shared.amountEmployees"),
      value: "Test data",
    },
    {
      icon: "/images/icons/user.svg",
      label: t("main.profileViewTabs.editProfile.form.topics"),
      value: "Test data",
    },
    {
      icon: "/images/icons/user.svg",
      label: t("main.groupsInfoForm.keywords"),
      value: "Test data",
    },
    {
      icon: "/images/icons/user.svg",
      label: t("main.profileViewTabs.editProfile.form.moreInformation.imprint"),
      value: "Test data",
    },
    {
      icon: "/images/icons/user.svg",
      label: t("main.profileViewTabs.editProfile.form.moreInformation.termsCondition"),
      value: "Test data",
    },
  ];

  return (
    <div className="flex flex-col gap-2">
      {fields.map(field => (
        <>
          <InfoField icon={field.icon} label={field.label} value={field.value} />
        </>
      ))}
    </div>
  );
};
export default ClubProfileContainer;
